import { ActivityEntityName, Entity } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';
import { AccountContactMergeData, AccountMergeData, AccountMergeSchema, BasicSiteMergeData, BasicSiteMergeSchema, CompanyMergeData, CompanyMergeSchema, ContactMergeData, ContactMergeSchema, SaleOrderItemsMergeData, SaleOrderItemsMergeDataSchema, SaleOrderMergeData, SaleOrderMergeSchema } from '../data';

@MergeDataset({
    entity: ActivityEntityName.SaleOrder,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class SaleOrderMergeDataset {

    @MergeSource({
        schema: SaleOrderMergeSchema
    })
    saleOrder?: SaleOrderMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
        displayName: "Sale Order Customer"
    })
    customer?: AccountMergeData;

    @MergeSource({
        schema: ContactMergeSchema,
        displayName: "Sale Order Customer Contact"
    })
    customerContact?: AccountContactMergeData;

    @MergeSource({
        schema: CompanyMergeSchema,
        displayName: "Sale Order Billing Company"
    })
    billingCompany?: CompanyMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    saleOrderJobSite?: BasicSiteMergeData;

    @MergeSource({
        schema: SaleOrderItemsMergeDataSchema
    })
    saleOrderItem?: SaleOrderItemsMergeData;

    public theme: Entity;
}